const setPolyfills = () => {
  // @ts-ignore
  Promise.allSettled = function (promises: any) {
    let mappedPromises = promises.map((p: any) => {
      return p
        .then((value: any) => {
          return {
            status: "fulfilled",
            value,
          };
        })
        .catch((reason: any) => {
          return {
            status: "rejected",
            reason,
          };
        });
    });
    return Promise.all(mappedPromises);
  };
};

export default setPolyfills;
